import type { JSX } from "react";
import { Link } from "react-router-dom";
import { firstPermittedRoute } from "../components/layout/nav";
import { useAccess } from "../auth/useAccess";
import { Icon } from "../components/ui/Icon";

/** 403 — authenticated, but the access level is insufficient. The canvas's
 *  "You don't have access" state, which names the permission rather than
 *  saying only that something was refused. */
export function ForbiddenPage(): JSX.Element {
  const { atLeast, can } = useAccess();
  // The way out has to be a page this principal can actually open. A fixed link
  // to /dashboard sent anyone without the dashboard module straight back here.
  const home = firstPermittedRoute({ atLeast, can });

  return (
    <div className="state-screen" data-testid="forbidden-page">
      <div className="state-mark state-mark-warning">
        <Icon name="alertTriangle" size={18} />
      </div>
      <h2>You don&apos;t have access</h2>
      <p>
        This area requires permission your account does not hold. Ask an
        administrator to grant it.
      </p>
      <div className="state-actions">
        {home && (
          <Link className="btn btn-secondary" to={home}>
            Go to my start page
          </Link>
        )}
        {/* The canvas puts "Request access" beside the way out. There is no
            endpoint that raises a request and no administrator address to
            address it to, so it is offered and plainly cannot act, rather
            than being a button that swallows the click. */}
        <button
          type="button"
          className="btn state-request"
          disabled
          title="Requesting access needs an endpoint this deployment does not serve — ask an administrator directly."
        >
          Request access
        </button>
      </div>
    </div>
  );
}
